import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import {
  attentionQueryRoot,
  bankQueryRoot,
  occurrenceQueryRoot,
  summaryQueryRoot,
} from '../../../../shared/api/index.js';
import { paymentQueries } from '../queries/payment-queries.js';
import { deletePayment } from '../requests/delete-payment.js';

export const useDeletePaymentMutation = (): UseMutationResult<void, Error, string> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deletePayment,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: paymentQueries.lists(), refetchType: 'none' }),
        queryClient.invalidateQueries({ queryKey: occurrenceQueryRoot.all(), refetchType: 'none' }),
        queryClient.invalidateQueries({ queryKey: summaryQueryRoot.all(), refetchType: 'none' }),
        queryClient.invalidateQueries({ queryKey: bankQueryRoot.all(), refetchType: 'none' }),
        queryClient.invalidateQueries({ queryKey: attentionQueryRoot.all(), refetchType: 'all' }),
      ]);
    },
  });
};
